import { useEffect } from "react";

// Redireciona para uma URL de outro domínio, onde o <Navigate> do react-router não alcança
function ExternalRedirect({ to }) {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);

  return null;
}

export default ExternalRedirect;
